import React, { useEffect, useState } from "react";
import "./index.scss";
import TableListDetails from "./components/TableListDetails";
import ButtonNavigatorComponent from "../../../../components/ButtonNavigator";
import Header from "../Header/Header";
import FilterRow from "../FilterROw/FilterRow";
import { useHistory } from "react-router-dom";
import { getHoursManagementByIdUserAndIdProject } from "../../service";
import useAuthData from "../../../../hook/useAppData";
import { IAccountInfo, IBankHoursStatement, IHoursManagementDetails } from "./models";
import Spinner from "../../../../components/Spinner";

export default function ListDetailsHoursManagement({ match }) {
  const { token } = useAuthData();
  const [listValues, setListValues] = useState<IBankHoursStatement[]>();
  const [accountInfo, setAccountInfo] = useState<IAccountInfo>();
  const [dateTo, setDateTo] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [page, setPage] = useState(0);
  const [selectSize, setSelectSize] = useState(10);
  const [needSpinner, setNeedSpiner] = useState(true);

  const history = useHistory();
  const params = match?.params?.id;

  useEffect(() => {
    getListDetails();
  }, []);

  useEffect(() => {
    setNeedSpiner(true);
    setTimeout(() => {
      setNeedSpiner(false);
    }, 500);
  }, [listValues]);

  async function getListDetails(queryString: string = "") {
    const data: IHoursManagementDetails = await getHoursManagementByIdUserAndIdProject(`?${params}${queryString} `, token);
    setListValues(data?.bankHoursStatement?.reverse());
    setAccountInfo(data?.accountInfo);
  }

  function handleClickExit() {
    history.push("./");
  }

  return (
    <>
      <Spinner status={needSpinner}>
        <div className="container-hours-management container">
          <Header title={<TitleHeader accountInfo={accountInfo} />} exit={true} handleClickExit={handleClickExit} total={accountInfo?.total} />
          <FilterRow
            dateTo={dateTo}
            setDateTo={setDateTo}
            dateFrom={dateFrom}
            setDateFrom={setDateFrom}
            getListDetails={getListDetails}
            filterType="date"
          />
          <TableListDetails listDetails={listValues as IBankHoursStatement[]} page={page} selectSize={selectSize} />
          {listValues?.length ? (
            <ButtonNavigatorComponent
              className="width-select-size"
              list={listValues}
              page={page}
              setPage={setPage}
              selectSize={selectSize}
              setSelectSize={setSelectSize}
            />
          ) : (
            ""
          )}
        </div>
      </Spinner>
    </>
  );
}

function TitleHeader({ accountInfo }: { accountInfo: IAccountInfo }): JSX.Element {
  return (
    <>
      <div className="flex row  gap">
        <span className="prefix-title-hours-management center">Usuário:</span>
        <span> {accountInfo?.userName}</span>
      </div>
      <div className="flex row  gap">
        <span className="prefix-title-hours-management center">Projeto:</span>
        <span> {accountInfo?.projectName}</span>
      </div>
    </>
  );
}
